export default __webpack_public_path__ + "static/media/14.652de22f.webp";